import { createRouter, createWebHistory } from 'vue-router'
import isAuthenticatedGuard from './auth-guard'
import autoLoginGuard from './auth-guard-login'
import {isFinancePermission, isProyectaPermission} from './permission-guard'

const routes = [

  
  {
    path: '/',
    beforeEnter:[ isFinancePermission ],
    component: () => import('@/modules/finance/layout/financeLayout.vue'),
    children:[
        {
        path: 'dashboardadmin',
        name:'dashboardAdmin',
        component: () => import('@/modules/finance/pages/DashboardAdmin.vue')
      },
        {
        path: 'reportsadmin',
        name:'reportsAdmin',
        component: () => import('@/modules/finance/pages/ReportsAdmin.vue')
      },

       {
        path: 'business',
        name:'business',
        component: () => import('@/modules/finance/pages/Business.vue')
      },
      {
        path: 'dashboardfinance',
        name:'dashboardFinance',
        component: () => import('@/modules/finance/pages/DashboardFinance.vue')
      },
      {
        path: 'transactions',
        name:'transactionsFinance',
        component: () => import('@/modules/finance/pages/TransactionsFinance.vue')
      },
      {
        path: 'visitors',
        name:'visitorsFinance',
        component: () => import('@/modules/finance/pages/VisitorsFinances.vue')
      },
      {
        path: 'reports',
        name:'reportsFinance',
        component: () => import('@/modules/finance/pages/ReportsFinance.vue')
      },
      {
        path: 'catalogs',
        name:'catalogsFinance',
        component: () => import('@/modules/finance/pages/CatalogFinance.vue')
      },
       {
        path: 'usersfinance',
        name:'usersFinance',
        component: () => import('@/modules/finance/pages/UsersPage.vue')
      },
      { 
        path: '', 
        redirect: 'dashboardfinance'
      },
    ]
  },
  {
    path: '/login',
    name:'auth',
    beforeEnter:[ autoLoginGuard ],
    component: () => import('@/modules/auth/layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name:'login',
        component: () => import('@/modules/auth/pages/LoginPage.vue')
      },
      {
        path: 'forgot',
        name:'forgot',
        component: () => import('@/modules/auth/pages/ForgotPage.vue')
      },
      {
        path: 'reset/:id',
        name:'reset-pass',
        component: () => import('@/modules/auth/pages/ResetPage.vue'),
        props: ( router ) =>{
          const { id } = router.params
          return { id }
        }
      },   
    ]
  },
  {
    path: '/guidefinance',
    name:'guideFinance',
    beforeEnter:[ isAuthenticatedGuard ],
    component: () => import('@/modules/guide/GuideFinance.vue'),
  },
  

  { 
    path: '/:pathMatch(.*)*', 
    redirect: '/'
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
